export const releaseVersion: string = '1.189.0';
